import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer" style={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
        borderTop: "2px solid #667eea",
        padding: "10px 20px",
        fontSize: "13px",
        color: "#555",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <span style={{ fontWeight: "500" }}>
          <i className="fa fa-book" style={{ marginRight: "6px", color: "#667eea" }}></i>
          BizBooks &copy; {new Date().getFullYear()} P4 Systems
        </span>
        <span style={{ fontWeight: "500", color: "#764ba2" }}>
          <i className="fa fa-bolt" style={{ marginRight: "6px" }}></i>
          Powered by P4 Systems
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js